import { render, staticRenderFns } from "./ItemLabel.vue?vue&type=template&id=5e2cc60a&scoped=true&"
import script from "./ItemLabel.vue?vue&type=script&lang=js&"
export * from "./ItemLabel.vue?vue&type=script&lang=js&"
import style0 from "./ItemLabel.vue?vue&type=style&index=0&id=5e2cc60a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2cc60a",
  null
  
)

export default component.exports